import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import celebrityService from '../../services';
import StandardCelebrityCard from './StandardCelebrityCard';
import './CelebrityGrid.css';

const CelebrityGrid = () => {
  const navigate = useNavigate();
  const [celebrityTiers, setCelebrityTiers] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchCelebrityTiers();
  }, []);

  const fetchCelebrityTiers = async () => {
    try {
      setLoading(true);
      const tiers = await celebrityService.getCelebrityTiers();
      setCelebrityTiers(tiers);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Loading celebrity investors...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="error-container">
        <p>Error: {error}</p>
      </div>
    );
  }

  const handleSelectCelebrity = (celebrity) => {
    navigate(`/celebrity/${celebrity.investor_pb_id || celebrity.pb_id}`);
  };

  const renderCelebrityCard = (celebrity, tierName) => {
    return (
      <div 
        key={celebrity.investor_pb_id || celebrity.pb_id}
        className="card-wrapper"
        onClick={() => handleSelectCelebrity(celebrity)}
      >
        <StandardCelebrityCard celebrity={celebrity} />
      </div>
    );
  };

  const renderAllCelebrities = () => {
    // Get all celebrities from the "all" tier created by our service
    const allCelebrities = celebrityTiers?.all || [];
    
    if (allCelebrities.length === 0) return null;

    return (
      <div className="celebrity-grid">
        {allCelebrities.map(celebrity => renderCelebrityCard(celebrity, 'all'))}
      </div>
    );
  };

  const totalCelebrities = Object.values(celebrityTiers || {}).reduce(
    (total, tier) => total + (tier?.length || 0), 0
  );

  return (
    <div className="celebrity-grid-container">
      <div className="grid-header">
        <div className="header-content">
          <h1 className="page-title">Celebrity Investors</h1>
          <p className="page-subtitle">
            Explore {totalCelebrities} celebrity investment portfolios
          </p>
        </div>
      </div>

      <div className="grid-content">
        {renderAllCelebrities()}
      </div>
    </div>
  );
};

export default CelebrityGrid;